import { useState, useEffect } from "react";

export interface WatchdogRevival {
  mint: string;
  at: number;
  feed: string;
  symbol: string | null;
  name?: string | null;
  image?: string | null;
  mcUsd: number | null;
  top1: number | null;
  creatorPct: number | null;
  baselineMcUsd: number | null;
}

export interface WatchdogMultiplier extends WatchdogRevival {
  multiplier: number;
  maxMultiplier: number;
}

export interface WatchdogSnapshot {
  lastRun: number;
  tradableCount: number;
  verifiedTotal: number;
  leakCount: number;
  leaks: any[];
  quarantine: string[];
  falseBlockCount: number;
  falseBlocks: any[];
  revivalCount: number;
  revivals: WatchdogRevival[];
  multiplierCount: number;
  multipliers: WatchdogMultiplier[];
}

export function useWatchdog() {
  const [data, setData] = useState<WatchdogSnapshot>({
    lastRun: 0,
    tradableCount: 0,
    verifiedTotal: 0,
    leakCount: 0,
    leaks: [],
    quarantine: [],
    falseBlockCount: 0,
    falseBlocks: [],
    revivalCount: 0,
    revivals: [],
    multiplierCount: 0,
    multipliers: []
  });

  useEffect(() => {
    let active = true;

    const fetchSnapshot = async () => {
      try {
        const res = await fetch("/api/watchdog");
        if (res.ok) {
          const snapshot = await res.json();
          if (active) setData(snapshot);
        }
      } catch (e) {
        // ignore fetch errors
      }
    };

    fetchSnapshot();
    const interval = setInterval(fetchSnapshot, 10000); // 10s poll

    return () => {
      active = false;
      clearInterval(interval);
    };
  }, []);

  return data;
}
